export type TReportKey = 'incentive' | 'equipment' | 'facility' | 'user';

export type TReportFilterOption = {
  value: string | number;
  label: string;
};

/**
 * Report Filter Payload
 */
export type TReportFilterPayload = Record<string, (string | number)[] | string>;

/**
 * Get Report Filter Options
 */
export type TGetReportFiltersResponse = Record<string, TReportFilterOption[]>;
